module.exports = __webpack_public_path__ + "static/background-image-2779c357f724d3661ff3684566103d02.png";